import { type UseQueryResult, useQuery } from 'react-query';
import { CompantTypeService } from '@wealthlane/api-services/wealthlane-identity-service';
import {
  BrokerService,
  CompanyTransferAgentService,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetTransferAgentOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const transferAgentOptions = useQuery(
    ['getTransferAgentOptions'],
    async () => {
      return await handleRequest(
        CompanyTransferAgentService.getApiCustomerCompanyTransferAgentOptions()
      );
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      },
    }
  );

  return transferAgentOptions;
};

export default useGetTransferAgentOptions;
